SJ.UI.MOUSE_MODE = {
	PASS: 0,
	TEST_AND_PASS: 1,
	TEST_AND_BLOCK: 2,
	BLOCK: 3,
};

SJ.UI.Element = class {
	constructor(
		x = 0,
		y = 0,
		w = 0,
		h = 0,
		onMousePress = null,
		onMouseRelease = null,
		onMouseEnter = null,
		onMouseLeave = null,
		workingName = null,
		position = 'relative',
		onMouseWheelMoveUp = null,
		onMouseWheelMoveDown = null,
		audioObject = null,
		onDisabledMousePress = null,
		onDisabledMouseRelease = null
	) {
		this.isVisible = true;
		this.parent = null;
		this.children = [];

		this.x = x;
		this.y = y;

		this.w = w;
		this.h = h;

		this.position = position;
		this.zIndex = null;

		this.workingName = workingName;

		this.mouseMode = SJ.UI.MOUSE_MODE.PASS;
		this.isMouseIn = false;
		this.isPress = false;

		this.audioObject = audioObject;

		if (onMousePress) {
			this.onMousePress = onMousePress;
		}
		if (onMouseRelease) {
			this.onMouseRelease = onMouseRelease;
		}
		if (onDisabledMousePress) {
			this.onDisabledMousePress = onDisabledMousePress;
		}
		if (onDisabledMouseRelease) {
			this.onDisabledMouseRelease = onDisabledMouseRelease;
		}
		if (onMouseEnter) {
			this.onMouseEnter = onMouseEnter;
		}
		if (onMouseLeave) {
			this.onMouseLeave = onMouseLeave;
		}
		if (onMouseWheelMoveUp) {
			this.onMouseWheelMoveUp = onMouseWheelMoveUp;
		}
		if (onMouseWheelMoveDown) {
			this.onMouseWheelMoveDown = onMouseWheelMoveDown;
		}

		this.color = color(random(255), random(255), random(255), 180);

		this.drawColorBackground = false;

		this.showDiagnostics = false;
	}

	_draw() {
		if (!this.isVisible) {
			return;
		}

		// if(!this.isMouseIn)
		//   this.onMouseLeave();

		if (this.audioObject) this.audioObject._update();

		push();

		translate(this.x, this.y);

		if (this.drawColorBackground) {
			fill(this.color);
			rectMode(CORNER);
			rect(0, 0, this.w, this.h);
		}

		if (this.showDiagnostics) {
			console.log(this);
			// console.log(this.x, this.y);

			// if(this.orginalX)
			//   console.log(this.orginalX, this.orginalY);

			// console.log('------');
		}

		this.draw();

		this.forEachChild((child) => {
			child._draw();
		});

		pop();
	}

	forEachChild(callback) {
		this.children.forEach((child) => {
			callback(child);
		});
	}

	forEachChildReversed(callback) {
		for (let i = this.children.length - 1; i >= 0; i--) {
			const child = this.children[i];
			callback(child);
		}
	}

	addChild(drawable) {
		// if(drawable.position === 'absolute'){
		//   this.parent.addChild(drawable);
		// }

		// if(drawable.position === 'absolute' && this.parent){
		//   this.parent.addChild(drawable);
		// }
		// else{

		// if(drawable.position === 'absolute'){
		//   drawable.x -= this.x;
		//   drawable.y -= this.y;
		// }

		this.children.push(drawable);
		drawable.parent = this;
		// }
	}

	show() {
		this.isVisible = true;
	}

	hide() {
		this.isVisible = false;
	}

	// Returns true when catched mouse
	// Returns false when ignored mouse
	_mouseMoved() {
		if (!this.isVisible) {
			return false;
		}

		// if(this.disabled === true) {
		//   return false;
		// }

		for (let i = this.children.length - 1; i >= 0; i--) {
			const child = this.children[i];
			if (child._mouseMoved()) {
				return true;
			}
		}

		switch (this.mouseMode) {
			case SJ.UI.MOUSE_MODE.TEST_AND_PASS:
			case SJ.UI.MOUSE_MODE.TEST_AND_BLOCK:
				if (this._isMouseIn()) {
					// if(!this.disabled)
					// document.body.style.cursor = 'pointer';
					if (!this.isMouseIn) {
						this.isMouseIn = true;
						this.onMouseEnter();
						return this.mouseMode === SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
					}
				} else if (this.isMouseIn) {
					this.isMouseIn = false;
					this.onMouseLeave();
					// document.body.style.cursor = 'default';
				}
				break;

			case SJ.UI.MOUSE_MODE.BLOCK:
				if (this._isMouseIn()) {
					return true;
				}
				break;
		}

		return false;
	}

	// Returns true when catched mouse
	// Returns false when ignored mouse
	_mousePressed() {
		if (!this.isVisible) {
			return false;
		}

		// if(this.disabled === true) {
		//   return false;
		// }

		for (let i = this.children.length - 1; i >= 0; i--) {
			const child = this.children[i];
			if (child._mousePressed()) {
				return true;
			}
		}

		switch (this.mouseMode) {
			case SJ.UI.MOUSE_MODE.TEST_AND_PASS:
			case SJ.UI.MOUSE_MODE.TEST_AND_BLOCK:
				if (this._isMouseIn()) {
					this.isPress = true;

					if (!this.disabled) {
						if (this.onMousePress) this.onMousePress();
					} else {
						if (this.onDisabledMousePress) this.onDisabledMousePress();
					}

					return this.mouseMode === SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
				}
				break;

			case SJ.UI.MOUSE_MODE.BLOCK:
				if (this._isMouseIn()) {
					return true;
				}
				break;
		}

		return false;
	}

	// Returns true when catched mouse
	// Returns false when ignored mouse
	_mouseReleased() {
		if (!this.isVisible) {
			return false;
		}

		// if(this.disabled === true) {
		//   return false;
		// }

		for (let i = this.children.length - 1; i >= 0; i--) {
			const child = this.children[i];
			if (child._mouseReleased()) {
				return true;
			}
		}

		switch (this.mouseMode) {
			case SJ.UI.MOUSE_MODE.TEST_AND_PASS:
			case SJ.UI.MOUSE_MODE.TEST_AND_BLOCK:
				if (this.isPress) {
					this.isPress = false;
					if (this._isMouseIn()) {
						if (!this.disabled) {
							if (this.onMouseRelease) this.onMouseRelease();
						} else {
							if (this.onDisabledMouseRelease) this.onDisabledMouseRelease();
						}

						return true;
					}
				}
				break;

			case SJ.UI.MOUSE_MODE.BLOCK:
				if (this._isMouseIn()) {
					return true;
				}
				break;
		}

		return false;
	}

	_mouseWheelMoveUp() {
		if (this.onMouseWheelMoveUp) {
			this.onMouseWheelMoveUp();
		}
	}

	_mouseWheelMoveDown() {
		if (this.onMouseWheelMoveDown) {
			this.onMouseWheelMoveDown();
		}
	}

	_isMouseIn() {
		return this.isPointIn(SJ.mouseScreenX, SJ.mouseScreenY);
	}

	isPointIn(x, y) {
		const globalPos = this.getGlobalPosition();

		return (
			x >= globalPos.x &&
			x < globalPos.x + this.w &&
			y >= globalPos.y &&
			y < globalPos.y + this.h
		);
	}

	getGlobalPosition() {
		const pos = {
			x: this.x,
			y: this.y,
		};

		if (this.parent.getGlobalPosition && this.position !== 'absolute') {
			const parentPos = this.parent.getGlobalPosition();
			pos.x += parentPos.x;
			pos.y += parentPos.y;
		}

		return pos;
	}

	draw() { }
	onMousePress() { }
	onMouseRelease() { }
	onMouseEnter() { }
	onMouseLeave() { }
};

SJ.Label = class extends SJ.UI.Element {
	constructor(
		content,
		x,
		y,
		align = LEFT,
		vAlign = CENTER,
		fontSize = 18,
		fontColor = color(255, 255, 255),
		textStyle = NORMAL,
		strokeColor = color(80, 80, 80),
		strokeWeight = 0,
		fontFamily = SJ.mainFont
	) {
		super(x, y);

		this.content = `${content}`;
		this.align = align;
		this.vAlign = vAlign;
		this.fontFamily = fontFamily;
		this.fontSize = fontSize;
		this.fontColor = fontColor;
		this.strokeColor = strokeColor;
		this.strokeWeight = strokeWeight;
		this.textStyle = textStyle;
		this.scalar = 1;

		textSize(this.fontSize);
		this.setSize();

		// this.setPositionOnAlign();

		this.color = color(random(255), random(255), random(255), 180);
	}

	setSize() {
		if (typeof this.content === 'string') {
			const lines = this.content.split(/\n/gm);
			textSize(this.fontSize);

			let longestLineWidth = textWidth(lines[0]);

			for (let i = 1; i < lines.length; i++) {
				const lineWidth = textWidth(lines[i]);

				if (lineWidth > longestLineWidth) {
					longestLineWidth = lineWidth;
				}
			}

			this.w = longestLineWidth;
			this.h = lines.length * this.fontSize;
		}
	}

	alignPosition() {
		switch (this.align) {
			case CENTER:
				this.translateX -= this.w / 2;
				break;
			case RIGHT:
				this.translateX += this.w;
				break;
		}

		switch (this.vAlign) {
			case CENTER:
				this.translateY -= this.h / 2;
				break;
			case BOTTOM:
				this.translateY -= this.h;
				break;
		}
	}

	draw() {
		push();

		// fill(this.color)
		// rectMode(CORNER);
		// rect(0, 0, this.w, this.h);

		textFont(this.fontFamily);
		textStyle(this.textStyle);
		textSize(this.fontSize);

		textAlign(this.align, this.vAlign);

		strokeWeight(this.strokeWeight);
		stroke(this.strokeColor);

		fill(this.fontColor);

		this.setSize();

		text(this.content, 0, 0);

		pop();

		textFont(SJ.mainFont);
	}
};

SJ.Button = class extends SJ.UI.Element {
	constructor(
		caption,
		x,
		y,
		w,
		h,
		onMousePress,
		onMouseRelease,
		onMouseEnter,
		onMouseLeave,
		draw,
		overrideLabelDraw = false,
		active = false,
		disabled = false
	) {
		super(x, y, w, h, onMousePress, onMouseRelease, onMouseEnter, onMouseLeave);
		this.disabled = disabled;

		this.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;

		this.bgColor = color(10, 123, 199);
		this.active = active;

		this.label = new SJ.Label(caption, 0, 0, CENTER, CENTER, h * 0.6);

		if (overrideLabelDraw) {
			this.label.draw = () => {
				push();
				textSize(this.label.fontSize);
				textAlign(this.label.align, this.label.vAlign);
				text(this.label.content, this.label.x, this.label.y);
				pop();
			};
		}

		this.addChild(this.label);
	}

	draw() {
		if (this.disabled) {
			fill(37, 53, 64);
		} else {
			if (this.isMouseIn) {
				if (this.isPress) {
					fill(17, 91, 140);
				} else {
					fill(14, 143, 230);
				}
			} else {
				fill(this.bgColor);
			}
		}

		if (this.active) {
			stroke(color(255, 255, 100));
			strokeWeight(2);
		}

		rectMode(CORNER);
		rect(0, 0, this.w, this.h);
		translate(this.w / 2, this.h / 2);

		if (this.disabled) {
			fill(60);
		} else {
			fill(0);
		}

		noStroke();
	}
};

SJ.TextureButton = class extends SJ.UI.Element {
	constructor(
		x,
		y,
		caption = null,
		mainTexture = null,
		hoverTexture = null,
		disabledTexture = null,
		disabledHoverTexture = null,
		setSizeOn = null,
		onMousePress = null,
		onMouseRelease = null,
		onMouseEnter = null,
		onMouseLeave = null,
		disabled = false,
		widthOffset = 0.1,
		heightOffset = 0.1,
		horizontalAlign = LEFT,
		verticalAlign = TOP
	) {
		super(
			x,
			y,
			30,
			30,
			onMousePress,
			onMouseRelease,
			onMouseEnter,
			onMouseLeave
		);

		if (caption) {
			this.label = new SJ.Label(
				caption,
				this.w / 2,
				this.h / 2,
				CENTER,
				CENTER,
				16
			);
			this.addChild(this.label);
		}

		this.orginalX = x;
		this.orginalY = y;

		this.horizontalAlign = LEFT;
		this.verticalAlign = TOP;

		this.setSizeOn = setSizeOn ? setSizeOn : 'mainTexture';

		this.disabled = disabled;
		this.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;

		this.widthOffset = widthOffset;
		this.heightOffset = heightOffset;

		this.hoverAnimationIsMouseAlreadyOn = false;

		this.horizontalAlign = horizontalAlign;
		this.verticalAlign = verticalAlign;

		this.forceHoverTexure = false;

		if (this.setSizeOn === 'mainTexture') {
			if (!mainTexture && !disabledTexture) this.setSizeOn = 'hoverTexture';
			else if (!mainTexture && disabledTexture)
				this.setSizeOn = 'disabledTexture';
		}

		this.mainTextureAnimationDuration = 500;
		this.hoverTextureAnimationDuration = 85;
		this.disabledTextureAnimationDuration = 500;
		this.disabledHoverTextureAnimationDuration = 500;

		this.mainTextureTranslate = { x: 0, y: 0 };
		this.hoverTextureTranslate = { x: 0, y: 0 };
		this.disabledTextureTranslate = { x: 0, y: 0 };
		this.disabledHoverTextureTranslate = { x: 0, y: 0 };

		if (mainTexture) {
			const setSizeOnThis = this.setSizeOn === 'mainTexture' ? true : false;
			this.mainTexture = this.getTexture(
				mainTexture,
				this.mainTextureAnimationDuration,
				setSizeOnThis
			);
		}

		if (hoverTexture) {
			const setSizeOnThis = this.setSizeOn === 'hoverTexture' ? true : false;
			this.hoverTexture = this.getTexture(
				hoverTexture,
				this.hoverTextureAnimationDuration,
				setSizeOnThis
			);
		}

		if (disabledTexture) {
			const setSizeOnThis = this.setSizeOn === 'disabledTexture' ? true : false;
			this.disabledTexture = this.getTexture(
				disabledTexture,
				this.disabledTextureAnimationDuration,
				setSizeOnThis
			);
		}

		if (disabledHoverTexture) {
			const setSizeOnThis =
				this.setSizeOn === 'disabledHoverTexture' ? true : false;
			this.disabledHoverTexture = this.getTexture(
				disabledHoverTexture,
				this.disabledTextureAnimationDuration,
				setSizeOnThis
			);
		}

		this.color = color(random(255), random(255), random(255), 180);
	}

	getTexture(sourceTexture, duration, setSizeOnThis) {
		if (typeof sourceTexture === 'string') {
			const preparedTexture = new SJ.Texture(
				sourceTexture,
				0,
				0,
				null,
				null,
				() => {
					if (setSizeOnThis) {
						this.setSize(preparedTexture.w, preparedTexture.h);
						if (this.label) {
							this.label.x = this.w / 2;
							this.label.y = this.h / 2;
						}
					}
				},
				null,
				null
			);

			return preparedTexture;
		} else if (Array.isArray(sourceTexture)) {
			const preparedTexture = new SJ.AnimatedTexture(
				sourceTexture,
				0,
				0,
				duration,
				() => {
					if (setSizeOnThis) {
						this.setSize(preparedTexture.w, preparedTexture.h);
						if (this.label) {
							this.label.x = this.w / 2;
							this.label.y = this.h / 2;
						}
					}
				}
			);

			return preparedTexture;
		} else if (typeof sourceTexture === 'object') {
			if (setSizeOnThis) {
				this.setSize(
					sourceTexture.predefindedWidth,
					sourceTexture.predefinedHeight
				);
				if (this.label) {
					this.label.x = this.w / 2;
					this.label.y = this.h / 2;
				}
			}

			return sourceTexture;
		}
	}

	setSize(w, h) {
		this.w = w - w * this.widthOffset;
		this.h = h - h * this.heightOffset;

		if (this.horizontalAlign === CENTER) {
			this.x -= this.w / 2;
		}

		if (this.verticalAlign === CENTER) {
			this.y -= this.h / 2;
		}

		// if(this.label){
		//   this.label.x = this.w / 2;
		//   this.label.y = this.h / 2;
		// }

		this.setAlign(this.horizontalAlign, this.verticalAlign);
	}

	setMainTextureTranslate(x, y) {
		this.mainTextureTranslate = { x: x, y: y };
	}

	setHoverTextureTranslate(x, y) {
		this.hoverTextureTranslate = { x: x, y: y };
	}

	setDisabledTextureTranslate(x, y) {
		this.disabledTextureTranslate = { x: x, y: y };
	}

	setAlign(horizontal, vertical) {
		if (horizontal) {
			this.horizontalAlign = horizontal;

			if (this.horizontalAlign === CENTER) this.x = this.orginalX - this.w / 2;
			else if (this.horizontalAlign === LEFT) this.x = this.orginalX;
		}

		if (vertical) {
			this.verticalAlign = vertical;

			if (this.verticalAlign === CENTER) this.y = this.orginalY - this.h / 2;
			else if (this.verticalAlign === TOP) this.y = this.orginalY;
		}
	}

	draw() {
		// fill(this.color)
		// rectMode(CORNER);
		// rect(0, 0, this.w, this.h);

		if (this.mainTexture && !this.disabled) {
			push();
			translate(
				this.w / 2 - this.mainTexture.w / 2,
				this.h / 2 - this.mainTexture.h / 2
			);
			translate(this.mainTextureTranslate.x, this.mainTextureTranslate.y);
			this.mainTexture.draw();
			pop();
		}

		if (this.disabledTexture && this.disabled) {
			push();
			translate(
				this.w / 2 - this.disabledTexture.w / 2,
				this.h / 2 - this.disabledTexture.h / 2
			);
			translate(
				this.disabledTextureTranslate.x,
				this.disabledTextureTranslate.y
			);
			this.disabledTexture.draw();
			pop();
		}

		if (
			(this.isMouseIn && !this.disabled && this.hoverTexture) ||
			(this.forceHoverTexure && this.hoverTexture)
		) {
			if (this.hoverTexture.animation && !this.hoverAnimationIsMouseAlreadyOn) {
				this.hoverTexture.animation.restart();
			}

			this.hoverAnimationIsMouseAlreadyOn = true;

			push();
			translate(
				this.w / 2 - this.hoverTexture.w / 2,
				this.h / 2 - this.hoverTexture.h / 2
			);
			translate(this.hoverTextureTranslate.x, this.hoverTextureTranslate.y);
			this.hoverTexture.draw();
			pop();
		}

		if (this.isMouseIn && this.disabled && this.disabledHoverTexture) {
			if (
				this.disabledHoverTexture.animation &&
				!this.disabledHoverAnimationIsMouseAlreadyOn
			) {
				this.disabledHoverTexture.animation.restart();
			}

			this.disabledHoverAnimationIsMouseAlreadyOn = true;

			push();
			translate(
				this.w / 2 - this.disabledHoverTexture.w / 2,
				this.h / 2 - this.disabledHoverTexture.h / 2
			);
			translate(
				this.disabledHoverTextureTranslate.x,
				this.disabledHoverTextureTranslate.y
			);
			this.disabledHoverTexture.draw();
			pop();
		}

		if (!this.isMouseIn) {
			this.hoverAnimationIsMouseAlreadyOn = false;
			this.disabledHoverAnimationIsMouseAlreadyOn = false;
		}
	}
};

SJ.Texture = class extends SJ.UI.Element {
	constructor(
		texture,
		x,
		y,
		w = null,
		h = null,
		onload = null,
		fitToWidth = null,
		fitToHeight = null,
		imageMode = CORNER
	) {
		super(x, y);

		this.predefindedWidth = w;
		this.predefinedHeight = h;

		this.scaleX = 1.0;
		this.scaleY = 1.0;

		this.fitToWidth = fitToWidth;
		this.fitToHeight = fitToHeight;

		this.imageMode = imageMode;

		this.texturePath = texture;

		this.setTexture(texture, onload);
	}

	setTexture(texture, onload = null) {
		if (typeof texture === 'string') {
			this.texture = SJ.ImageLoader.load(texture, () => {
				if (this.fitToWidth) this.texture.resize(this.fitToWidth, 0);
				else if (this.fitToHeight) this.texture.resize(0, this.fitToHeight);

				this.w = this.predefindedWidth
					? this.predefindedWidth
					: this.texture.width;
				this.h = this.predefinedHeight
					? this.predefinedHeight
					: this.texture.height;

				if (this.imageMode === CENTER) {
					this.x -= this.w / 2;
					this.y -= this.h / 2;
				}

				if (onload) {
					onload();
				}
			});
		} else {
			this.texture = texture;

			this.w = this.predefindedWidth
				? this.predefindedWidth
				: this.texture.width;
			this.h = this.predefinedHeight
				? this.predefinedHeight
				: this.texture.height;

			if (this.imageMode === CENTER) {
				this.x -= this.w / 2;
				this.y -= this.h / 2;
			}

			if (onload) {
				onload();
			}
		}
	}

	draw() {
		image(this.texture, 0, 0, this.w * this.scaleX, this.h * this.scaleY);
	}
};

SJ.SpriteSheetTexture = class extends SJ.Texture {
	constructor(
		texture,
		x,
		y,
		w = null,
		h = null,
		ssX,
		ssY,
		ssW,
		ssH,
		scaleX = 1.0,
		scaleY = 1.0,
		onload = null,
		imageMode = CORNER
	) {
		super(texture, x, y, w | ssW, h | ssH, onload, null, null, imageMode);

		this.scaleX = scaleX;
		this.scaleY = scaleY;

		this.ssW = ssW;
		this.ssH = ssH;

		this.ssX = ssX;
		this.ssY = ssY;
	}

	draw() {
		image(
			this.texture,
			this.x,
			this.y,
			this.w * this.scaleX,
			this.h * this.scaleY,
			this.ssX,
			this.ssY,
			this.ssW,
			this.ssH
		);
	}
};

SJ.SpriteSheetTexture2 = class extends SJ.Texture {
	constructor(
		texture,
		x,
		y,
		w = null,
		h = null,
		ssX,
		ssY,
		ssW,
		ssH,
		scaleX = 1.0,
		scaleY = 1.0,
		onload = null,
		imageMode = CORNER
	) {
		super(texture, x, y, w | ssW, h | ssH, onload, null, null, imageMode);

		this.scaleX = scaleX;
		this.scaleY = scaleY;

		this.ssW = ssW;
		this.ssH = ssH;

		this.ssX = ssX;
		this.ssY = ssY;

		this.w *= scaleX;
		this.h *= scaleY;
	}

	draw() {
		image(
			this.texture,
			0,
			0,
			this.w,
			this.h,
			this.ssX,
			this.ssY,
			this.ssW,
			this.ssH
		);
	}
};

SJ.AnimatedTexture = class extends SJ.UI.Element {
	constructor(
		texturesArray,
		x,
		y,
		duration,
		onload = null,
		imageMode = CORNER
	) {
		super(x, y);
		this.imageMode = imageMode;
		this.animation = new SJ.Animation([], duration, true, true, true);
		this.setTextures(texturesArray, onload);
	}

	setTextures(texturesArray, onload = null) {
		const loadedTexturesArray = [];
		let loadedTextures = 0;

		for (let i = 0; i < texturesArray.length; i++) {
			const textureName = texturesArray[i];

			if (typeof textureName === 'string') {
				let frame = SJ.ImageLoader.load(textureName, () => {
					loadedTexturesArray[i] = frame;

					if (onload) {
						loadedTextures++;
						if (loadedTextures >= texturesArray.length) {
							this.w = frame.width;
							this.h = frame.height;

							if (this.imageMode === CENTER) {
								this.x -= this.w / 2;
								this.y -= this.h / 2;
							}

							onload();

							// Prevent running onload second time
							loadedTextures = 0;
						}
					}
				});
			} else {
				loadedTexturesArray[i] = textureName;
				if (onload) {
					loadedTextures++;
				}
			}
		}

		if (onload) {
			if (loadedTextures >= texturesArray.length) {
				onload();
			}
		}

		this.animation.frames = loadedTexturesArray;
	}

	draw() {
		this.animation.draw();
	}
};

SJ.AnimatedSpriteSheet = class extends SJ.UI.Element {
	constructor(
		ss,
		x,
		y,
		duration,
		frameW,
		frameH,
		framesCount,
		autostart = true,
		loopMode = true,
		resetAtEnd = true,
		onload = null
	) {
		super(x, y);

		this.w = frameW;
		this.h = frameH;

		this.animation = new SJ.AnimationSpriteSheet(
			ss,
			frameW,
			frameH,
			framesCount,
			duration,
			autostart,
			loopMode,
			resetAtEnd,
			onload
		);
	}

	draw() {
		this.animation.draw();
	}
};

SJ.Layout = class extends SJ.UI.Element {
	constructor(
		x,
		y,
		children = [],
		spacing = 20,
		direction = 'row',
		horizontalAlign = LEFT,
		autoSpacing = false,
		w = 0,
		h = 0
	) {
		super(x, y, 0, 0);

		this.orginalX = x;
		this.orginalY = y;

		this.w = w;
		this.h = h;

		this.autoSpacing = autoSpacing;

		this.fixedWidth = this.w === 0 || !this.w ? false : true;
		this.fixedHeight = this.h === 0 || !this.h ? false : true;

		// if(spacing)
		//   this.autoSpacing = false;

		// if(!this.w && !this.h)
		//   this.autoSpacing = false;

		this.horizontalAlign = horizontalAlign;
		this.verticalAlign = CENTER;

		this.children = children;
		this.spacing = spacing;
		this.direction = direction;

		this.setChilrensParent();
		this.setupLayoutObjectsPosition();

		this.color = color(random(255), random(255), random(255));
	}

	setChilrensParent() {
		this.children.forEach((child) => {
			child.parent = this;
		});
	}

	setupLayoutObjectsPosition() {
		if (this.children.length === 0) return;

		if (!this.fixedWidth) this.setLayoutWidth();

		if (!this.fixedHeight) this.setLayoutHeight();

		if (this.autoSpacing) {
			this.setSpacing();
		}

		let curX = 0;
		let curY = 0;

		if (!this.parent) this.setAlign();
		else {
			if (!this.parent.setupLayoutObjectsPosition) {
				this.setAlign();
			}
		}

		this.children.forEach((element) => {
			if (element.isVisible) {
				if (element.content) {
					element.align = LEFT;
					element.vAlign = TOP;
				}

				if (this.direction === 'row') {
					switch (this.verticalAlign) {
						case TOP:
							curY = this.orginalY;
							break;
						case CENTER:
							curY = this.h / 2 - element.h / 2;
							break;

						case BOTTOM:
							break;
					}

					element.x = curX;
					element.y = curY;

					if (element.workingName == 'spritesheet') {
						element.x = curX;
						element.y = curY;
					}

					if (this.autoSpacing) {
						curX += element.w + this.spacing;
					} else {
						curX += element.w + this.spacing;
					}
				} else if (this.direction === 'column') {
					switch (this.horizontalAlign) {
						case CENTER:
							curX = this.w / 2 - element.w / 2;
							break;

						case RIGHT:
							curX = this.w - element.w;
							break;
					}

					element.x = curX;
					element.y = curY;

					if (this.autoSpacing) {
					} else {
						curY += element.h + this.spacing;
					}
				}
			}
		});
	}

	setAlign() {
		if (this.horizontalAlign === CENTER) {
			this.x = this.orginalX - this.w / 2;
		} else if (this.horizontalAlign === LEFT) {
			this.x = this.orginalX;
		} else if (this.horizontalAlign === RIGHT) {
			this.x = this.orginalX - this.w;
		}

		if (this.verticalAlign === CENTER) {
			this.y = this.orginalY - this.h / 2;
		} else if (this.verticalAlign === TOP) {
			this.y = this.orginalY;
		} else if (this.verticalAlign === BOTTOM) {
			this.y = this.orginalY - this.h;
		}
	}

	setLayoutWidth() {
		this.w = 0;

		if (this.direction === 'row') {
			this.children.forEach((element) => {
				if (element.isVisible) this.w += element.w + this.spacing;
			});

			this.w -= this.spacing;
		} else if (this.direction === 'column') {
			this.children.forEach((element) => {
				if (element.w > this.w && element.isVisible) this.w = element.w;
			});
		}
	}

	setLayoutHeight() {
		this.h = 0;

		if (this.direction === 'column') {
			this.children.forEach((element) => {
				if (element.isVisible) this.h += element.h + this.spacing;
			});

			this.h -= this.spacing;
		} else if (this.direction === 'row') {
			this.children.forEach((element) => {
				if (element.h > this.h && element.isVisible) this.h = element.h;
			});
		}
	}

	setSpacing() {
		if (this.direction === 'row') {
			let totalElementsWidth = 0;
			let elementsCount = 0;

			this.children.forEach((object) => {
				if (object.isVisible) {
					totalElementsWidth += object.w;
					elementsCount++;
				}
			});

			const freeSpace = this.w - totalElementsWidth;

			this.spacing =
				freeSpace / elementsCount < 0 ? 0 : freeSpace / (elementsCount - 1);
		} else if (this.direction === 'height') {
			let totalElementsHeight = 0;
			let elementsCount = 0;

			this.children.forEach((object) => {
				if (object.isVisible) {
					totalElementsHeight += object.h;
					elementsCount++;
				}
			});

			const freeSpace = this.h - totalElementsHeight;

			this.spacing =
				freeSpace / elementsCount < 0 ? 0 : freeSpace / (elementsCount - 1);
		}
	}

	addChild = (drawable) => {
		drawable.parent = this;
		this.children.push(drawable);
	};

	draw() {
		// push();
		//   fill(this.color);
		//   rectMode(CORNER);
		//   rect(0, 0, this.w, this.h);
		// pop();

		this.setupLayoutObjectsPosition();
	}
};

SJ.TextWindow = class extends SJ.UI.Element {
	constructor(
		x,
		y,
		txt,
		txtSize = 16,
		textColor = color(255),
		bgColor = color(0, 10, 50)
	) {
		super(x, y, 0, 0);

		this.textColor = textColor;
		this.bgColor = bgColor;

		this._setPadding(10, 10, 10, 10);
		this._setTextSize(txtSize);
		this._setText(txt);

		this._calculateSize();
	}

	draw() {
		push();
		fill(this.bgColor);
		stroke(255);
		rectMode(CORNER);
		rect(0, 0, this.w, this.h);

		textSize(this.textSize);
		textAlign(LEFT, TOP);
		fill(this.textColor);
		noStroke();
		text(this.text, this._paddingLeft, this._paddingTop);
		pop();
	}

	_calculateSize() {
		const lines = this.text.split(/\n/gm);
		textSize(this.textSize);
		let longestLineWidth = textWidth(lines[0]);
		for (let i = 1; i < lines.length; i++) {
			const lineWidth = textWidth(lines[i]);
			if (lineWidth > longestLineWidth) {
				longestLineWidth = lineWidth;
			}
		}
		this.w = longestLineWidth + this._paddingLeft + this._paddingRight;
		this.h =
			lines.length * this.textSize + this._paddingTop + this._paddingBottom;
	}

	setText(txt) {
		this._setText(txt);
		this._calculateSize();
	}

	_setText(txt) {
		this.text = txt;
	}

	setTextSize(txtSize) {
		_setTextSize(txtSize);
		this._calculateSize();
	}

	_setTextSize(txtSize) {
		this.textSize = txtSize;
	}

	setPadding(pLeft, pRight, pTop, pBottom) {
		this._setPadding(pLeft, pRight, pTop, pBottom);
		this._calculateSize();
	}

	_setPadding(pLeft, pRight, pTop, pBottom) {
		this._paddingLeft = pLeft;
		this._paddingRight = pRight;
		this._paddingTop = pTop;
		this._paddingBottom = pBottom;
	}
};

SJ.MouseFollowingPopup = class extends SJ.UI.Element {
	constructor(
		txt,
		txtSize = 16,
		textColor = color(255),
		bgColor = color(0, 10, 50)
	) {
		super();
		this.isVisible = false;
		this.popup = new SJ.TextWindow(0, 0, txt, txtSize, textColor, bgColor);
		this.children.push(this.popup);
	}

	draw() {
		const maxX = SJ.SCREEN_WIDTH - this.popup.w;
		const maxY = SJ.SCREEN_HEIGHT - this.popup.h;
		const x = max(min(maxX, SJ.mouseScreenX - this.popup.w / 2), 0);
		const y = max(min(maxY, SJ.mouseScreenY - this.popup.h - 10), 0);
		translate(x, y);
	}
};

SJ.DrawableRect = class extends SJ.UI.Element {
	constructor(x, y, w, h, col) {
		super(x, y, w, h);
		this.color = col;
		this.mode = CORNER;
	}

	draw() {
		push();
		rectMode(this.mode);
		fill(this.color);
		noStroke();
		rect(0, 0, this.w, this.h);
		pop();
	}
};

SJ.Popup = class extends SJ.DrawableRect {
	constructor(w, h, drawable) {
		super(0, 0, SJ.SCREEN_WIDTH, SJ.SCREEN_HEIGHT, color(0, 0, 0, 100));
		this.isVisible = false;
		this.mouseMode = SJ.UI.MOUSE_MODE.BLOCK;

		this.bgRect = new SJ.DrawableRect(
			SJ.SCREEN_MIDDLE_X,
			SJ.SCREEN_MIDDLE_Y,
			w,
			h,
			color(50, 70, 140)
		);
		this.bgRect.mode = CENTER;
		this.addChild(this.bgRect);

		drawable.forEach((el) => {
			this.addChild(el);
		});
	}
};

SJ.LabelWithBackground = class extends SJ.DrawableRect {
	constructor(
		txt,
		x,
		y,
		w,
		h,
		txtSize = 16,
		col = color(255),
		bgColor = color(0),
		align = LEFT,
		vAlign = CENTER
	) {
		super(x, y, w, h, bgColor);

		let lx = 0;
		let ly = 0;

		switch (align) {
			case LEFT:
				lx = 10;
				break;
			case CENTER:
				lx = w / 2;
				break;
			case RIGHT:
				lx = w - 10;
				break;
		}
		switch (vAlign) {
			case TOP:
				ly = 10;
				break;
			case CENTER:
				ly = h / 2;
				break;
			case BOTTOM:
				ly = h - 10;
				break;
		}

		this.label = new SJ.Label(txt, lx, ly, align, vAlign, txtSize, col);
		this.children.push(this.label);
	}
};
